import { useFitnessStore } from '../../../store/fitnessStore';
import { Home, Dumbbell, Apple, Trophy, Heart, TrendingUp, User } from 'lucide-react';
import { motion } from 'framer-motion';

const NAV = [
  { id: 'home', Icon: Home, label: 'Home' },
  { id: 'workout', Icon: Dumbbell, label: 'Train' },
  { id: 'nutrition', Icon: Apple, label: 'Fuel' },
  { id: 'sport', Icon: Trophy, label: 'Sport' },
  { id: 'wellness', Icon: Heart, label: 'Wellness' },
  { id: 'progress', Icon: TrendingUp, label: 'Progress' },
  { id: 'profile', Icon: User, label: 'Profile' },
];

export default function BottomNav() {
  const activeScreen = useFitnessStore((s) => s.activeScreen);
  const setScreen = useFitnessStore((s) => s.setScreen);

  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 50,
      background: 'rgba(10,10,11,0.97)', borderTop: '1px solid rgba(255,255,255,0.05)',
      display: 'flex', justifyContent: 'space-around', padding: '8px 0 max(12px, env(safe-area-inset-bottom))',
      backdropFilter: 'blur(20px)',
    }}
    >
      {NAV.map(({ id, Icon, label }) => {
        const active = activeScreen === id;
        return (
          <motion.button
            key={id}
            type="button"
            onClick={() => setScreen(id)}
            whileTap={{ scale: 0.92 }}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, padding: '4px 6px', background: 'none', border: 'none', cursor: 'pointer', minWidth: 40 }}
          >
            <div style={{ padding: 6, borderRadius: 8, background: active ? 'rgba(232,255,71,0.12)' : 'transparent', transition: 'background 0.2s' }}>
              <Icon size={18} strokeWidth={active ? 2.5 : 1.8} color={active ? '#E8FF47' : 'rgba(255,255,255,0.3)'} />
            </div>
            <span style={{ fontSize: 8, fontFamily: 'DM Sans', fontWeight: 600, letterSpacing: 0.3, color: active ? '#E8FF47' : 'rgba(255,255,255,0.28)', transition: 'color 0.2s' }}>{label}</span>
          </motion.button>
        );
      })}
    </nav>
  );
}
